var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { border: "1px solid transparent" }, attrs: { id: "app" } },
    [
      _c(
        "keep-alive",
        [_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e()],
        1
      ),
      _vm._v(" "),
      !_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "addr-pop",
          attrs: { closeable: "", round: "" },
          model: {
            value: _vm.showAddr,
            callback: function($$v) {
              _vm.showAddr = $$v
            },
            expression: "showAddr"
          }
        },
        [
          _c("h2", { staticClass: "h" }, [_vm._v("請選擇收貨地址")]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.addrList, function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "addr-list",
                  on: {
                    click: function($event) {
                      _vm.selectAddr(item)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(item.address) + "\n      ")]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "block btn-addr", on: { click: _vm.goToAddr } },
            [_vm._v("新建收貨地址")]
          )
        ]
      ),
      _vm._v(" "),
      _c("loading", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading"
          }
        ]
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 